import { z } from 'zod';
import { mediaFileSchema, mediaFileWebSchema } from './mediaFile';

export const focalPointSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export type FocalPoint = z.infer<typeof focalPointSchema>;

export const imageDimensionsSchema = z.object({
  height: z.number().int().positive(),
  width: z.number().int().positive(),
  // bit depth?
  // bytes?
});

export type ImageDimensions = z.infer<typeof imageDimensionsSchema>;

export const srcSetSchema = z.object({
  contentType: z.string(),
  dimensions: imageDimensionsSchema,
  src: z.string(),
});

export type SrcSet = z.infer<typeof srcSetSchema>;

export const imageSchema = mediaFileSchema.extend({
  focalPoint: focalPointSchema.optional(),
  altText: z.string().optional(),
});

export type Image = z.infer<typeof imageSchema>;

export const imageWebSchema = mediaFileWebSchema.extend({
  dimensions: imageDimensionsSchema.optional(),
  blurHash: z.string().optional(),
  focalPoint: focalPointSchema.optional(),
  altText: z.string().optional(),
  srcSet: z.array(srcSetSchema).optional(),
});

export type ImageWeb = z.infer<typeof imageWebSchema>;

export const imageScaleSchema = z.enum(['none', 'cover', 'contain']);

export type ImageScale = z.infer<typeof imageScaleSchema>;

export const imageTileSchema = z.enum(['none', 'repeat', 'repeat-x', 'repeat-y']);

export type ImageTile = z.infer<typeof imageTileSchema>;
